const getApiUrl = () => {
    let url = null;
    if (process.env.NODE_ENV === 'development') {
        url = 'https://localhost:5001';
    }
    if (process.env.NODE_ENV === 'production') {
        if (process.env.REACT_APP_WEBSITE_NAME === 'tecnometrics') {
            url = 'https://api.mtrack.com.br';
        }
    }
    if (!url) {
        throw new Error('Url da api não foi definida.');
    }
    return url;
};

export const ConnectionParams = {
    apiUrl: getApiUrl(),
};
